<template>
  <div >
    <my-header :activeIndex="0" />
    <img src="../../assets/index/top-img.jpg" style="width: 100%" />
    <div class="info-content">
      <div class="news">
        <a  class="hot"
          >游哉游戏平台：欢迎您选择我们</a
        >
        <ul class="newsList">
          <li class="cu">
            &nbsp;&nbsp;&nbsp;&nbsp;游哉游戏平台为广大玩家提供丰富的精品手游，并提供全方位的游戏服务和优质的游戏体验。
          </li>
          <li class="cu">
            &nbsp;&nbsp;&nbsp;&nbsp;作为一家专业的手游运营平台，致力于与众多知名游戏开发商合作，为玩家提供最新、最热门、最惊艳的手游作品。我们不仅涵盖了各类游戏类型，包括冒险、角色扮演、射击、策略等，还拥有丰富的游戏题材，满足不同玩家的需求。
          </li>
          <li class="cu">
            &nbsp;&nbsp;&nbsp;&nbsp;游哉游戏平台的特色之一是我们精心挑选的游戏内容。我们的团队在全球范围内深入研究游戏市场趋势，不断关注玩家的反馈和需求，以确保为玩家提供优质游戏。无论您是追求刺激的竞技游戏、沉浸式的剧情体验还是休闲放松的休闲游戏，游哉游戏平台都能满足您的需求。
          </li>
        </ul>
      </div>
      <div>
        <img style="width: 100%" src="../../assets/index/content.png" />
      </div>
    </div>
    <div class="banner swiper-container">
      <swiper :options="swiperOption">
          <swiper-slide v-for="(item, index) in swiperData" :key="index">
            <img class="cu" :src="item.url" alt="" />
            <div class="swiper-slide-text">
            <div class="swiper-icon">
              <img :src="item.icon" />
            </div>
            <div class="main-content">
              <p class="text-font">{{ item.text }}</p>
              <p class="content">{{ item.content }}</p>
              <p class="content">{{ item.content1 }}</p>
              <p class="content">{{ item.content2 }}</p>
            </div>
            <div class="down">
              <!-- <div @click="handleJumpGame" class="go-game cu">前往游戏</div> -->
              <img
                class="cu"
                @click="open(item.android)"
                src="../../assets/index/android.png"
              />
            </div>
          </div>
          </swiper-slide>
          <div class="swiper-button-prev custom-button-prev" slot="button-prev">
            &lt;
          </div>
          <div class="swiper-button-next custom-button-next" slot="button-next">
            &gt;
          </div>
        </swiper>
    </div>
    <!-- <div
      class="bg"
      :style="
        hoverIndex
          ? `background: url(${bottomData[hoverIndex].background})`
          : `background: url(${bottomData[0].background})`
      "
    >
      <div class="info">
        <div
          class="popAlert"
          v-for="(item, index) in bottomData"
          :key="index"
          @mouseenter.stop="mouseenter($event, index)"
          @mouseleave="hideText"
        >
          <div
            class="info-img"
            :style="hoverIndex === index ? styleIndex : null"
            ref="elememt"
          >
            <img :src="item.url" alt="" />
            <div class="box" :style="hoverIndex === index ? boxStyle : null">
              <div class="box-content">
                <p class="img">
                  <img :src="item.icon" />
                </p>
                <div class="box-text">{{ item.name }}</div>
              </div>
            </div>
          </div>
          <div :class="hoverIndex === index ? 'icon-text' : 'icon-text-none'">
            <p>{{item.type}}</p>
            <div class="divider"></div>
            <div class="icon-img-box">
              <div class="icon-img-flex cu" @click="open('')">
                游戏礼包<img class="icon-img" src="../../assets/index/gift.png" />
              </div>
              <div class="icon-img-flex cu" @click="open(item.android)">
                免费下载<img class="icon-img" src="../../assets/index/down.png" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <my-footer />
    <my-top />
  </div>
</template>
<script>
import MyFooter from "./MyFooter.vue";
import MyHeader from "./MyHeader.vue";
import MyTop from "./MyTop.vue";
export default {
  name: "index",
  data() {
    return {
      hoverIndex: null,
      styleIndex: null,
      boxStyle: null,
      swiperData: [
        {
          url: require("../../assets/index/banner-02.jpg"),
          icon: require("../../assets/index/icon-02.png"),
          text: "守护者之森",
          content: "著作权人：上海绿岸网络科技股份有限公司",
          content1: "出版单位：上海绿岸网络科技股份有限公司",
          content2: "运营单位：上海绿岸网络科技股份有限公司",
          android:
            "https://down.longmaotech.com/source_apk/65/961.1.2024121616482195.apk",
        },
        {
          url: require("../../assets/index/banner-01.jpg"),
          icon: require("../../assets/index/icon-01.png"),
          text: "九州仙剑传",
          content: "著作权人：成都雨墨科技有限公司",
          content1: "出版单位：上海绿岸网络科技股份有限公司",
          content2: "运营单位：海南丰际网络科技有限公司",
          android: "https://down.longmaotech.com/tf/msg_jc/66_158_1_1052.apk",
        },
      ],
      bottomData: [
        // {
        //   url: require("../../assets/index/bottom-01.png"),
        //   icon: require("../../assets/index/icon-01.png"),
        //   background: require("../../assets/index/bottom-bg-01.png"),
        //   name: "琴剑封魔录",
        //   android: "https://down.longmaotech.com/tf/msg_jc/66_158_1_1052.apk",
        //   type: "角色扮演",
        // },
        {
          url: require("../../assets/index/bottom-02.png"),
          icon: require("../../assets/index/icon-02.png"),
          background: require("../../assets/index/bottom-bg-02.png"),
          name: "守护者之森",
          android: "https://down.longmaotech.com/source_apk/65/961.1.2024121616482195.apk",
          type: "策略游戏",
        },
        // {
        //   url: require("../../assets/index/bottom-03.png"),
        //   icon: require("../../assets/index/icon-03.png"),
        //   background: require("../../assets/index/bottom-bg-03.png"),
        //   name: "天之禁",
        //   android: "https://down.longmaotech.com/tf/lmminigame/103_856_1_1001.apk",
        //   type: "卡牌游戏",
        // },
        // {
        //   url: require("../../assets/index/bottom-04.png"),
        //   icon: require("../../assets/index/icon-04.png"),
        //   background: require("../../assets/index/bottom-bg-04.png"),
        //   name: "疯狂超赛战士",
        //   android: "https://down.longmaotech.com/tf/landing/104_878_1_1001.apk",
        //   type: "卡牌游戏",
        // },
      ],
      contentData: [
        {
          text: "《守护者之森》周年新大区今日江湖再续",
          date: "10/25",
        },
        {
          text: "《守护者之森》周年新大区预约开启",
          date: "10/23",
        },
        {
          text: "《守护者之森》周年新服激情再续",
          date: "10/21",
        },
        {
          text: "2024年度武侠卡牌大作推荐《守护者之森》",
          date: "10/19",
        },
        {
          text: "《守护者之森》三周年狂欢盛典开启",
          date: "10/17",
        },
        {
          text: "《守护者之森》荣耀八区新服今日开启",
          date: "10/15",
        },
        {
          text: "《守护者之森》五周年新服即将开启",
          date: "10/13",
        },
        {
          text: "《守护者之森》超级赛亚人成长记，新服今日开启!",
          date: "10/11",
        },
        {
          text: "《守护者之森》【佳偶天成】今日火爆开启",
          date: "10/09",
        },
      ],
      swiperOption: {
        loop: true,
        autoplay: {
          delay: 5000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        // 设置点击箭头
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
    };
  },
  components: {
    "my-footer": MyFooter,
    "my-header": MyHeader,
    "my-top": MyTop,
  },
  methods: {
    handleJumpGame() {},
    handlJumpNews() {
      this.$router.replace("/mobile/news");
    },
    open(url) {
      if (url == "") {
        this.$message.warning("敬请期待!");
      } else {
        window.open(url);
      }
    },
    mouseenter(event, index) {
      let { offsetY } = event;
      let { offsetHeight } = this.$refs.elememt[index];
      let mouseenHeight = offsetHeight - offsetY;
      // if (mouseenHeight > 20) {
      this.hoverIndex = index;
      this.styleIndex =
        "bottom:70px;  box-shadow:8px 8px 8px rgba(0, 0, 0, 0.2),8px -8px 8px rgba(0, 0, 0, 0.2),-8px 8px 8px rgba(0, 0, 0, 0.2),-8px -8px 8px rgba(0, 0, 0, 0.2);";
      this.boxStyle = "bottom: 0;";
      // } else {
      //   this.hoverIndex = null;
      //   this.boxStyle = null;
      //   this.infoStyle = null;
      // }
    },
    hideText() {
      this.hoverIndex = null;
      this.boxStyle = null;
      this.infoStyle = null;
    },
    downloadBtn() {
      window.location.href =
        "https://down.longmaotech.com/tf/msg_jc/66_158_1_1052.apk";
    },
    downloadBtn1() {
      window.location.href =
        "https://down.longmaotech.com/tf/landing/89_575_2_1001.apk";
    },
    downloadBtn2() {
      window.location.href =
        "https://down.longmaotech.com/source_apk/65/961.1.2024121616482195.apk";
    },
  },
};
</script>
<style scoped>
@import url(../../../css/index-phone.min.css);
</style>



// WEBPACK FOOTER //
// src/components/mobile/index.vue